require('features/routing');
require('features/articleSearchBox');
require('features/articleCardCarousel');
require('../components/listingsForYouSection');
require('../components/metroSpecificSection');
require('features/segment');
require('features/googleAnalytics4');
require('./components/eventTracking/googleAnalytics4EventsHandler');
require('./components/eventTracking/segmentEventsHandler');
require('../components/popularPillsCarousel');
require('../handlers/hyperlinkCardHandler');
